import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { navigator, TShipperSettings } from '@types';
import { isBulkUploadHiddenForUser } from '@utils';

const shipperNav = (
	sID: string = '',
	isAdmin: boolean = false,
	userRoles: string[] = [],
	shipperSettings: TShipperSettings | null = null,
	isShipperActive: boolean = true
) => {

	const sIDQuery = sID !== '' ? `?sid=${sID}` : '';
	const bulkUploadHidden = isBulkUploadHiddenForUser({
		userRoles,
		internalBulkUploadOff: shipperSettings?.internal_bulkupload_off
	});
	const bulkUploadEnabled = isAdmin || (shipperSettings?.bulk_upload_shipments_enabled ?? false);
	let shipperMenuItems = [
		{
			label: 'Dashboard',
			icon: (color: string) => <DashboardOutlinedIcon style={{ color: color }} />,
			link: `/shipper/dashboard${sIDQuery}`,
			enabled: isAdmin,
			activeURL: 'dashboard'
		},
		{
			label: 'Today',
			icon: (color: string) => <TodayOutlinedIcon style={{ color: color }} />,
			link: `/shipper/today${sIDQuery}`,
			enabled: isShipperActive || isAdmin,
			activeURL: 'today'
		},
		{
			label: 'Shipments',
			icon: (color: string) => <ListAltIcon style={{ color: color }} />,
			link: `/shipper/orders${sIDQuery}`,
			enabled: isShipperActive || isAdmin,
			activeURL: 'orders'
		},
		{
			label: 'Upload Shipments',
			icon: (color: string) => <UploadFileIcon style={{ color: color }} />,
			link: `/shipper/bulk-uploads${sIDQuery}`,
			enabled: bulkUploadEnabled && isShipperActive,
			activeURL: 'bulk-uploads'
		},
		{
			label: 'Book a Shipment',
			icon: (color: string) => <ControlPointIcon style={{ color: color }} />,
			link: `/shipper/booking/dashboard${sIDQuery}`,
			enabled: (isShipperActive),
			activeURL: `booking`
		},
		{
			label: 'Rate Cards',
			icon: (color: string) => <PriceChangeOutlinedIcon style={{ color: color }} />,
			link: `/shipper/ratecards${sIDQuery}`,
			enabled: isAdmin,
			activeURL: 'ratecards'
		},
		{
			label: 'Quotes',
			icon: (color: string) => <RequestQuoteOutlinedIcon style={{ color: color }} />,
			link: `/shipper/quotes${sIDQuery}`,
			enabled: (isShipperActive || isAdmin),
			activeURL: 'quotes'
		},
		{
			label: 'Invoices',
			icon: (color: string) => <ReceiptOutlinedIcon style={{ color: color }} />,
			link: `/shipper/invoices${sIDQuery}`,
			enabled: isShipperActive || isAdmin,
			activeURL: 'invoices'
		},
		{
			label: 'Analytics',
			icon: (color: string) => <TrendingUpOutlinedIcon style={{ color: color }} />,
			link: `/shipper/analytics${sIDQuery}`,
			enabled: isShipperActive || isAdmin,
			activeURL: 'analytics'
		},
		{
			label: 'Company Details',
			icon: (color: string) => <StoreOutlinedIcon style={{ color: color }} />,
			link: `/shipper/company/profile${sIDQuery}`,
			enabled: isShipperActive || isAdmin,
			activeURL: 'company'
		},
		{
			label: 'Settings',
			icon: (color: string) => <SettingsOutlinedIcon style={{ color: color }} />,
			link: `/shipper/settings${sIDQuery}`,
			enabled: isShipperActive || isAdmin,
			activeURL: 'settings'
		}
	] as navigator[];

	shipperMenuItems = shipperMenuItems.filter((item: navigator) => {
		switch (item.activeURL) {
		case 'today':
		case 'orders':
		case 'booking':
			return isAdmin || userRoles.some((r) => ['team', 'manager', 'booking manager'].includes(r));
		case 'bulk-uploads':
			if (bulkUploadHidden) return false;
			return isAdmin || (userRoles.some((r) => ['team', 'manager', 'booking manager'].includes(r)) && (shipperSettings?.bulk_upload_shipments_enabled ?? false));
		case 'quotes':
		case 'invoices':
		case 'analytics':
		case 'profile':
		case 'company':
			return isAdmin || userRoles.some((r) => ['team', 'manager'].includes(r));
		case 'dashboard':
		case 'ratecards':
		case 'settings':
			return isAdmin;
		default:
			return true;
		}
	}).filter((item: navigator) => {
		if (isAdmin && sID === '') {
			return item.activeURL === 'dashboard';
		} else {
			return item;
		}
	});

	return shipperMenuItems;
}

export default shipperNav;
